import React, {FC} from 'react';
import classNames from 'classnames';
import {Sharing} from 'templates/reports/Sharing/mutation.sharing';

import LinkIcon from './svgs/link.inline.svg';
import ShareIcon from './svgs/share.inline.svg';
import {makeLink, useCopy} from './useCopy';

import * as styles from './styles.module.scss';

type CopyLinkProps = {
	sharing: Sharing
}

export const CopyLink: FC<CopyLinkProps> = ({sharing}) => {
	const {copied, onCopy} = useCopy(sharing.cache);
	const onShare = () => {
		navigator.share({
			title: 'BodySpec DEXA Scan',
			text: 'Check out my report!',
			url: makeLink(sharing.cache),
		});
	};

	if (!sharing.enabled) {
		return (
			<div className={styles.wrapper}>
				<div className={classNames(styles.copy, styles.disabled)}>
					<LinkIcon />
					<span>Sharing disabled</span>
				</div>
			</div>
		);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.copy} onClick={onCopy}>
				<LinkIcon />
				<span>{copied}</span>
			</div>
			<div className={styles.share} onClick={onShare}>
				<ShareIcon />
			</div>
		</div>
	);
};
